export default __webpack_public_path__ + "static/media/ETH-USDT.a33b6cfd.svg";